const c = {
  name: "BahrainiDinar",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,19.6h2.7v2.7H7V19.6z"/>
		<path class="st0" d="M12.3,20.4c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0c0.7,0,1.4-0.2,2-0.6
			c0.1-0.1,0.2-0.1,0.2-0.2c-0.1-0.7-0.4-1.3-0.9-1.7c-0.5-0.6-1.2-1-1.8-1.4c-0.2-0.1-0.3-0.2-0.3-0.3c0.1-0.4,0.2-0.7,0.5-1h0.1
			c0.8,0.5,1.5,1.1,2.2,1.9c0.5,0.6,0.8,1.3,0.9,2.1c0,0.5-0.1,1.1-0.4,1.6c-0.7,0.5-1.6,0.8-2.5,0.8c-1,0-1.7-0.6-1.7-1.9
			c0-0.2,0-0.4,0-0.7h0.4C12.2,20.1,12.2,20.3,12.3,20.4z"/>
		<path class="st0" d="M18.4,19.6h2.7v2.7h-2.7V19.6z"/>
		<path class="st0" d="M23.2,19.5c0,2.2,1.9,3.1,4.4,3.1c1.7,0,3.3-0.4,4.9-1c0.3-0.4,0.5-1,0.5-1.5c-0.1-1-0.4-1.9-0.9-2.8h0
			c-0.2,0.3-0.5,0.6-0.7,1c0.4,0.7,0.7,1.4,0.9,2.2c0,0,0,0.1-0.1,0.1c-0.4,0.2-0.8,0.3-1.2,0.4c-1,0.2-2,0.4-3.1,0.4
			c-2.3,0-4.1-0.8-4.1-2.6c0-0.5,0.1-0.9,0.3-1.4l-0.4-0.2C23.4,18,23.2,18.8,23.2,19.5z"/>
		<path class="st0" d="M29.1,25.3c-0.3-0.4-0.7-0.7-1.1-1c-0.3,0.3-0.5,0.6-0.7,1l0,0c0.3,0.3,0.7,0.6,1,0.9
			C28.6,25.9,28.9,25.6,29.1,25.3z"/>
		<path class="st0" d="M20,0c-4,0-7.8,1.2-11.1,3.4c-3.3,2.2-5.9,5.3-7.4,9C0,16-0.4,20,0.4,23.9c0.8,3.9,2.7,7.4,5.5,10.2
			c2.8,2.8,6.4,4.7,10.2,5.5C20,40.4,24,40,27.7,38.5c3.7-1.5,6.8-4.1,9-7.4C38.8,27.8,40,24,40,20c0-5.3-2.1-10.4-5.9-14.1
			S25.3,0,20,0z M20,38c-3.6,0-7-1.1-10-3c-3-2-5.3-4.8-6.6-8.1s-1.7-6.9-1-10.4C3,13,4.8,9.8,7.3,7.3C9.8,4.8,13,3,16.5,2.3
			c3.5-0.7,7.1-0.3,10.4,1C30.2,4.7,33,7,35,10c2,3,3,6.4,3,10c0,4.8-1.9,9.4-5.3,12.7C29.4,36.1,24.8,38,20,38z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as BahrainiDinar
};
